<template>
  <section class="copyright__wrap">
    <div class="copyright__section">
      <p class="page-footer__copyright">2011 - {{ currentYear }} © Dnipro-M</p>
    </div>
    <div class="payment-card">
      <span class="payment-card__text">{{ $t('footer.we.accepted') }}</span>
      <ul class="payment-card__list">
        <li class="payment-card__item">
          <img src="/img/svgo/product-page/visa.svg" alt="visa" />
        </li>
        <li class="payment-card__item">
          <img src="/img/svgo/product-page/mastercard.svg" alt="mastercard" />
        </li>
        <li class="payment-card__item">
          <img src="/img/svgo/product-page/pb24.svg" alt="privat24" />
        </li>
        <li class="payment-card__item">
          <img src="/img/svgo/product-page/pb-pay-part.svg" alt="pay-part" />
        </li>
        <li class="payment-card__item">
          <img src="/img/svgo/product-page/monobank.svg" alt="monobank" />
        </li>
        <li class="payment-card__item">
          <img src="/img/svgo/product-page/apple-pay.svg" alt="apple-pay" />
        </li>
        <li class="payment-card__item">
          <img src="/img/svgo/product-page/google-pay.svg" alt="google-pay" />
        </li>
      </ul>
    </div>
    <FooterSocial />
  </section>
</template>

<script>
import FooterSocial from './FooterSocial'
import { spritePath } from '@/mixins/spritePath'

export default {
  name: 'FooterCopyright',
  mixins: [spritePath],
  components: {
    FooterSocial
  },
  computed: {
    currentYear () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped lang="sass">

.copyright
  width: 100%
  background-color: $white-text-color

.copyright__wrap
  display: flex
  justify-content: flex-start
  padding: 44px 0 46px
  border-top: 1px solid #494949
  align-items: center

  +mmax(768)
    display: flex
    flex-direction: column
    justify-content: space-between
    padding: 40px 0 40px
    align-items: flex-start

.copyright__section
  width: 25%

  +mmax(768)
    width: 100%
    margin-top: 40px
    order: 2

.page-footer__copyright
  font-weight: 400
  font-size: 14px
  color: $white-text-color
  margin: 0

.payment-card
  width: 50%

  +mmax(768)
    width: 100%
    margin-bottom: 40px

.payment-card__list
  display: flex
  align-items: center
  list-style: none
  padding: 0
  margin: 0

.payment-card__text
  display: none
  font-weight: 400
  font-size: 14px
  line-height: 17px
  color: #909090
  margin-bottom: 20px

  +mmax(768)
    display: block

.payment-card__item
  display: flex
  flex-shrink: 0

.payment-card__item:not(:last-child)
  margin-right: 13px
</style>
